import type { ProfileTabKey } from '@wlb/shared/constants/profileTabs';

/** Empty-state copy per profile tab. */
export const EMPTY_MESSAGE_KEYS: Record<ProfileTabKey, string> = {
  posts: 'profile.empty.posts',
  activities: 'profile.empty.activities',
  all: 'profile.empty.posts',
  photos: 'profile.empty.photos',
  videos: 'profile.empty.videos',
};
